import type { EditorStarterItem } from '../item-type';
import { isTextItem } from '../text/text-item-type';
import type { GroupItem } from './group-item-type';

/** 그룹 라벨 최대 길이 — 초과분은 잘라낸다. */
const MAX_LABEL_LENGTH = 20;

/**
 * 그룹의 대표 라벨을 멤버 텍스트에서 뽑는다.
 *
 * 우선순위:
 * - children 이 참조하는 멤버 중 type==='text' 이고 내용(trim)이 비지 않은 것들에서
 *   fontSize 가 가장 큰 멤버의 텍스트. 동률이면 children 순서상 앞쪽이 이긴다.
 * - text 멤버가 하나도 없으면 null. i18n/포맷 관심사는 caller 에 둔다.
 * - items 에 없는 childId 는 방어적으로 무시한다.
 *
 * 반환 텍스트는 trim 후 최대 20자로 truncate 한다.
 */
export const getGroupItemLabel = (
  group: GroupItem,
  items: Record<string, EditorStarterItem>,
): string | null => {
  if(group.children.length>0&&group.children.every(id=>items[id]?.type==='audio')) return `병합 음성 (${group.children.length})`;
  let bestText: string | null = null;
  let bestFontSize = -Infinity;

  for (const childId of group.children) {
    const member = items[childId];
    if (!member || !isTextItem(member)) continue;

    const text = member.text.trim();
    if (text === '') continue;

    // 동률이면 앞쪽을 유지하도록 엄격한 초과(>)일 때만 교체한다.
    if (member.fontSize > bestFontSize) {
      bestFontSize = member.fontSize;
      bestText = text;
    }
  }

  if (bestText === null) return null;
  return bestText.slice(0, MAX_LABEL_LENGTH);
};
